module.exports = __webpack_public_path__ + "static/img/8bg_5.a253856.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/8bg_5.png
// module id = 765
// module chunks = 1